import { skipToken, useQuery } from '@tanstack/react-query'
import { returnsApi } from '@/services/api/returns-api'
import { ReturnsApiExchangeTimingsRequest } from '@itsrever/rever-api'

export const useExchangeTimings = ({
  ecommerceId,
  returnsExchangeTimingsRequest
}: ReturnsApiExchangeTimingsRequest) => {
  return useQuery({
    queryKey: ['exchange-timings', ecommerceId, returnsExchangeTimingsRequest],
    queryFn: ecommerceId
      ? async () => {
          const { data } = await returnsApi.exchangeTimings({
            ecommerceId,
            returnsExchangeTimingsRequest
          })

          return data
        }
      : skipToken,
    staleTime: Infinity,
    retry: false
  })
}
